module.exports = __webpack_public_path__ + "static/media/PreDisputeAlertHandlingAndDashboardGuideJune2024.cdc33a2a.pdf";